// TODO: These should be moved to the backend `/api/get_cyo_promos` if exp-139 Variant 1 wins
export const PROMO_ITEMS = [
  {
    image: {
      mobile: `/public/img/limited_time_promo_exp_139/FreshProduce-desktop-240px.jpg`,
      desktop: `/public/img/limited_time_promo_exp_139/FreshProduce-desktop-480px.jpg`,
      alt: 'fresh veggies',
    },
    title: 'Fresh veggie of the week',
    description: 'Ex: Leafy greens, potatoes, carrots, peppers, etc.',
    isPopular: false,
    value: 'CYOVEGGIES',
  },
  {
    image: {
      mobile: `/public/img/limited_time_promo_exp_139/SweetSnack-desktop-240px.jpg`,
      desktop: `/public/img/limited_time_promo_exp_139/SweetSnack-desktop-480px.jpg`,
      alt: 'sweets and snacks',
    },
    title: 'Sweet or snack of the week',
    description: 'Ex: Cookie doughs, popcorn, protein shakes, cheesecake, etc.',
    isPopular: true,
    value: 'CYOCOOKIEDOUGH',
  },
  {
    image: {
      mobile: `/public/img/limited_time_promo_exp_139/PremiumProtein-desktop-240px.jpg`,
      desktop: `/public/img/limited_time_promo_exp_139/PremiumProtein-desktop-480px.jpg`,
      alt: 'premium proteins',
    },
    title: 'Premium protein of the week',
    description: 'Ex: Poultry, seafood, or plant-based meats, etc.',
    isPopular: false,
    value: 'CYOPROTEIN',
  },
];
